import type { StencilUnknown } from '../types';

export interface EventDetail {
	name: string;
	value: StencilUnknown;
}
